import * as Yup from "yup";
import formWiclax from "./formWiclax";

const { filenamePdf, filenameWiclax, urllink } = formWiclax;

const validationWiclax = Yup.object().shape({
  [filenamePdf.name]: Yup.array().of(Yup.string()),
  [filenameWiclax.name]: Yup.string().required(filenameWiclax.errorMsg),
  [urllink.name]: Yup.string(),
});

export { validationWiclax };
